/**
 * O sino do topo (Alertas.dc.html): as notificações da pessoa (as não lidas em
 * destaque e contadas no sino), os alertas urgentes do escritório e "Ver todos
 * os alertas". Abrir uma notificação marca como lida e leva até ela.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Botao from '../egora/Botao';
import { avisar, mensagemDeErro } from '../shared/Notificacao';
import { useAlertas, useMinhasNotificacoes } from './dadosCasca';
import { useEscritasDosAlertas } from './escritasDosAlertas';
import { quandoComHora } from './recentes';

/** "Prazo vence hoje: Quesitos da perícia" — o título do prazo é o começo do texto do alerta. */
function textoDoUrgente(a) {
  if (!String(a.chave).startsWith('prazo:')) return a.titulo;
  return `${a.titulo}: ${a.texto.split(', no processo')[0].split('. ')[0]}`;
}

export default function SinoDeNotificacoes({ aberto, onAlternar, onFechar }) {
  const navigate = useNavigate();
  const { itens, naoLidas } = useMinhasNotificacoes();
  const { alertas } = useAlertas();
  const { marcarLidas, marcarTodas } = useEscritasDosAlertas();
  const urgentes = alertas.filter((a) => a.nivel === 'agora').slice(0, 2);
  const recentes = itens.slice(0, 4);

  const ir = (rota) => { onFechar(); navigate(rota); };
  const abrir = (n) => {
    if (!n.lida) marcarLidas([n.id]).catch((e) => avisar(mensagemDeErro(e, 'marcar como lida'), 'erro'));
    ir(n.link || '/alertas?aba=notificacoes');
  };
  const lerTodas = () => marcarTodas().catch((e) => avisar(mensagemDeErro(e, 'marcar como lidas'), 'erro'));

  return (
    <div className="sj-ancora">
      <Botao
        variante="fantasma"
        icone="notifications"
        className="casca-com-contador"
        aria-label={naoLidas > 0 ? `Notificações, ${naoLidas} ${naoLidas > 1 ? 'novas' : 'nova'}` : 'Notificações'}
        aria-haspopup="true"
        aria-expanded={aberto}
        onClick={onAlternar}
      >
        {naoLidas > 0 && <span className="sj-contador" aria-hidden="true">{naoLidas > 9 ? '9+' : naoLidas}</span>}
      </Botao>
      {aberto && (
        <div className="sj-lista sj-lista--direita casca-sino__lista">
          <div className="casca-sino__cabeca">
            <strong>Notificações</strong>
            {naoLidas > 0 && <Botao variante="fantasma" tamanho="sm" onClick={lerTodas}>Marcar como lidas</Botao>}
          </div>
          {recentes.map((n) => (
            <Botao key={n.id} item className={`casca-sino__item${n.lida ? '' : ' casca-sino__item--nova'}`} onClick={() => abrir(n)}>
              <span className="sj-avatar casca-sino__sigla" aria-hidden="true">{n.sigla}</span>
              <span className="casca-busca__textos">
                <span className="casca-sino__texto">{n.texto}{!n.lida && <span className="sj-oculto"> (não lida)</span>}</span>
                <span className="legenda casca-busca__sub">{quandoComHora(n.quando)}</span>
              </span>
            </Botao>
          ))}
          {urgentes.map((a) => (
            <Botao key={a.chave} item className="casca-sino__item" onClick={() => ir('/alertas')}>
              <span className="sj-avatar casca-sino__sigla" aria-hidden="true">EG</span>
              <span className="casca-busca__textos">
                <span className="casca-sino__texto">{textoDoUrgente(a)}</span>
                <span className="legenda casca-busca__sub">Alerta do escritório</span>
              </span>
            </Botao>
          ))}
          {recentes.length === 0 && urgentes.length === 0 && (
            <div className="casca-busca__vazio" role="status">Nenhuma notificação por enquanto.</div>
          )}
          <Botao item className="casca-sino__todos" onClick={() => ir('/alertas')}>Ver todos os alertas</Botao>
        </div>
      )}
    </div>
  );
}
